import ApparelSizeSpec from '../../../../../pages/vip/features/appareal-size-spec/apparel-size-spec.mobile';

export default ApparelSizeSpec;
